/**
 * @copyright (C) 2023, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Soonki Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Thu Mar 23 2023
 **/

import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { Row } from "../../../Layouts";
import { TypographyCSS } from "../../../Typography";

export const Wrapper = styled(Row)<{
	colortheme: "blue" | "purple" | "orange" | "selago" | "gray" | "red";
	hasavatar?: "true" | "false";
	isEllipsisText?: boolean;
}>`
	padding: ${({ hasavatar }) => (hasavatar === "true" ? "4px" : "4px 4px 4px 10px")};
	border-radius: 18px;
	width: fit-content;
	max-width: 100%;
	word-break: break-word;
	.typo {
		${TypographyCSS("Body3")}
		white-space: ${({ isEllipsisText }) => (isEllipsisText ? "nowrap" : "unset")};
		overflow: hidden;
		text-overflow: ellipsis;
		color: ${({ colortheme, theme }) =>
			colortheme === "red" ? theme.colors.error_60_100 : theme.colors.neutral_80_100};
	}
	background: ${({ colortheme }) => {
		switch (colortheme) {
			case "blue":
				return "#DEEBFD";
			case "purple":
				return "#E5E2F8";
			case "selago":
				return "#F1E2FB";
			case "orange":
				return "#FDEDE2";
			case "gray":
				return "#D9D9D9";
			case "red":
				return "#FFE8ED";
		}
	}};

	color: ${({ colortheme }) => colortheme === "orange" && "#EF6C16"};

	&:hover {
		background: ${({ colortheme, theme }) => {
			switch (colortheme) {
				case "blue":
					return "linear-gradient(0deg, rgba(98, 130, 242, 0.08), rgba(98, 130, 242, 0.08)), #DEEBFD;";
				case "purple":
					return "linear-gradient(0deg, rgba(148, 109, 212, 0.08), rgba(148, 109, 212, 0.08)), #E5E2F8;";
				case "selago":
					return "linear-gradient(0deg, rgba(195, 108, 22, 0.08), rgba(195, 108, 22, 0.08)), #F1E2FB;";
				case "orange":
					return "linear-gradient(0deg, rgba(239, 108, 22, 0.08), rgba(239, 108, 22, 0.08)), #FDEDE2;";
				case "gray":
					return theme.colors.secondary_80_8;
			}
		}};

		.typo {
			white-space: unset;
		}
	}

	&:active {
		background: ${({ colortheme, theme }) => {
			switch (colortheme) {
				case "blue":
					return "linear-gradient(0deg, rgba(98, 130, 242, 0.12), rgba(98, 130, 242, 0.12)), #DEEBFD;";
				case "purple":
					return "linear-gradient(0deg, rgba(148, 109, 212, 0.12), rgba(148, 109, 212, 0.12)), #E5E2F8;";
				case "selago":
					return "linear-gradient(0deg, rgba(195, 109, 212, 0.12), rgba(195, 109, 212, 0.12)), #F1E2FB;";
				case "orange":
					return "linear-gradient(0deg, rgba(239, 108, 22, 0.12), rgba(239, 108, 22, 0.12)), #FDEDE2;";
				case "gray":
					return theme.colors.secondary_80_8;
			}
		}};
	}

	&:focus {
		background: ${({ colortheme, theme }) => {
			switch (colortheme) {
				case "blue":
					return "linear-gradient(0deg, rgba(98, 130, 242, 0.16), rgba(98, 130, 242, 0.16)), #DEEBFD;";
				case "purple":
					return "linear-gradient(0deg, rgba(148, 109, 212, 0.16), rgba(148, 109, 212, 0.16)), #E5E2F8;";
				case "selago":
					return "linear-gradient(0deg, rgba(195, 109, 212, 0.16), rgba(195, 109, 212, 0.16)), #F1E2FB;";
				case "orange":
					return "linear-gradient(0deg, rgba(239, 108, 22, 0.16), rgba(239, 108, 22, 0.16)), #FDEDE2;";
				case "gray":
					return theme.colors.secondary_80_8;
			}
		}};
	}
`;

export const IconCss = css`
	border-radius: 50%;
	transition: 0.3s;
	cursor: pointer;
	&:hover {
		background: rgba(50, 51, 56, 0.08);
		mix-blend-mode: normal;
	}
`;
